import React, { useEffect } from 'react'
import { Box, Button, Card, CardContent, Container, Grid, TextField, Typography } from '@mui/material'
import { Image } from '@mui/icons-material'
import CategoryCard from '../../components/CategoryCard'
import GalleryImage from '../../components/GalleryImage'
import MyCarousel from '../../components/MyCarousel'


function Home() {

    return (
        <>
            <MyCarousel />

            <Container sx={{ padding: { xs: "15px 10px", md: "20px 10px", lg: "40px 15px", }, textAlign: "center" }} >
                <Grid container spacing={10} style={{ alignItems: "center" }}>
                    <Grid item md={6} >
                        <Typography variant='h4' style={{ marginBottom: "15px", fontWeight: "bold", textAlign: "center" }} sx={{ fontSize: { xs: '28px', sm: '32px', md: '40px' } }}>About Our Grocery Shop</Typography>
                        {/* <Typography variant='h4' style={{ fontWeight: "bold", marginBottom:"15px" }} ></Typography> */}
                        <Typography textAlign={'justify'} >
                            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Est aut atque facere placeat recusandae ab reprehenderit nemo voluptas beatae molestiae explicabo, pariatur possimus neque quis rem tenetur hic qui praesentium aspernatur, ea quibusdam. Quia quisquam ullam deleniti quos libero incidunt voluptatem? Necessitatibus doloremque harum beatae praesentium. Dicta nostrum, officiis aspernatur eveniet, nesciunt iusto commodi quasi consequatur mollitia ipsa repellat fugiat magnam sequi voluptatibus modi beatae necessitatibus, qui architecto eius consequuntur! Cumque autem amet reprehenderit eaque sit corporis placeat ipsa eligendi sunt. Molestiae repudiandae non facilis, dolor itaque temporibus assumenda dicta, ipsa nam ipsam alias, hic ex rem recusandae harum est!  libero incidunt voluptatem? Necessitatibus doloremque harum beatae praesentium. Dicta nostrum, officiis aspernatur eveniet, nesciunt iusto commodi .
                        </Typography>
                    </Grid>
                    <Grid item md={6} >
                        <Box
                            component="img"
                            sx={{
                                height: 'auto',
                                width: '100%',
                                // margin: '10px auto'
                            }}
                            alt="The house from the offer."
                            src="./assets/image/shop.jpg"
                        />
                    </Grid>
                </Grid>
            </Container>
            <Container sx={{ padding: { xs: "15px 10px", md: "20px 10px", lg: "40px 15px" }, textAlign: "center" }}>
                <Typography variant='h4' style={{ marginBottom: "15px", fontWeight: "bold", textAlign: "center" }} sx={{ fontSize: { xs: '28px', sm: '32px', md: '40px' } }}>
                    Why Choose us ?
                </Typography>

                <Grid container sx={{ gap: { md: '0px', xs: '20px' } }} style={{ justifyContent: "center", }}>
                    <Grid item lg={3} md={6} sm={6} xs={12}>
                        <Box
                            component="img"
                            sx={{
                                height: 90,
                                width: 90,
                                margin: '10px auto'
                            }}
                            alt="The house from the offer."
                            src="./assets/image/delivery-bike.png"
                        />
                        <Typography style={{ fontWeight: 'bold' }} >
                            10 Minutes Delivery
                        </Typography>
                    </Grid>
                    <Grid item lg={3} md={6} sm={6} xs={12}>
                        <Box
                            component="img"
                            sx={{
                                height: 90,
                                width: 90,
                                margin: '10px auto'
                            }}
                            alt="The house from the offer."
                            src="./assets/image/discount.png"
                        />
                        <Typography style={{ fontWeight: 'bold' }} >
                            Upto 60% Discount
                        </Typography>
                    </Grid>
                    <Grid item lg={3} md={6} sm={6} xs={12}>
                        <Box
                            component="img"
                            sx={{
                                height: 90,
                                width: 90,
                                margin: '10px auto'
                            }}
                            alt="The house from the offer."
                            src="./assets/image/grocery-cart.png"
                        />
                        <Typography style={{ fontWeight: 'bold' }} >
                            10000+ Product Available
                        </Typography>
                    </Grid>
                    <Grid item lg={3} md={6} sm={6} xs={12}>
                        <Box
                            component="img"
                            sx={{
                                height: 90,
                                width: 90,
                                margin: '10px auto'
                            }}
                            alt="The house from the offer."
                            src="./assets/image/fresh.png"
                        />
                        <Typography style={{ fontWeight: 'bold' }} >
                            Fresh, Natural and Organic
                        </Typography>
                    </Grid>
                </Grid>
            </Container >
            <Container sx={{ padding: { xs: "15px 10px", md: "20px 10px", lg: "40px 15px" }, textAlign: "center" }}>
                <Typography variant='h4' style={{ marginBottom: "15px", fontWeight: "bold", textAlign: "center" }} sx={{ fontSize: { xs: '28px', sm: '32px', md: '40px' } }}>
                    Our Top Categories
                </Typography>
                <Grid container spacing={5} style={{ justifyContent: "center", gap: "15px" }}>
                    <Grid item>
                        <CategoryCard categoryName={"Vegetables"} categoryImage={"./assets/image/vegetable.jpg"} />
                    </Grid>
                    <Grid item>
                        <CategoryCard categoryName={"Fruits"} categoryImage={"./assets/image/fruit.jpg"} />
                    </Grid>
                    <Grid item>
                        <CategoryCard categoryName={"Meat"} categoryImage={"./assets/image/meat.png"} />
                    </Grid>
                    <Grid item>
                        <CategoryCard categoryName={"Dairy"} categoryImage={"./assets/image/milk.jpg"} />
                    </Grid>
                    <Grid item>
                        <CategoryCard categoryName={"Snacks"} categoryImage={"./assets/image/snacks.jpg"} />
                    </Grid>
                    <Grid item>
                        <CategoryCard categoryName={"Beverages"} categoryImage={"./assets/image/beverages.jpg"} />
                    </Grid>
                </Grid>
            </Container>
            <Container sx={{ padding: { xs: "15px 10px", md: "20px 10px", lg: "40px 15px" }, textAlign: "center" }}>
                <Typography variant='h4' style={{ marginBottom: "15px", fontWeight: "bold", textAlign: "center" }} sx={{ fontSize: { xs: '28px', sm: '32px', md: '40px' } }}>
                    Our Gallery
                </Typography>
                <Grid container spacing={5} style={{ justifyContent: "center" }}>
                    <Grid item md={4}>
                        <GalleryImage image="./assets/image/gallery2.jpg" />
                    </Grid>
                    <Grid item md={4}>
                        <GalleryImage image="./assets/image/gallery3.jpg" />
                    </Grid>
                    <Grid item md={4}>
                        <GalleryImage image="./assets/image/gallery4.jpg" />
                    </Grid>
                    <Grid item md={4}>
                        <GalleryImage image="./assets/image/gallery5.jpg" />
                    </Grid>
                    <Grid item md={4}>
                        <GalleryImage image="./assets/image/gallery7.jpg" />
                    </Grid>
                    <Grid item md={4}>
                        <GalleryImage image="./assets/image/gallery6.jpg" />
                    </Grid>
                </Grid>
            </Container>
            <Container sx={{ padding: { xs: "20px 10px", md: "20px 10px", lg: "40px 15px" }, textAlign: "center" }}>
                <Grid container spacing={5} style={{ justifyContent: "space-between" }}>
                    <Grid item md={6}>
                        <Typography variant='h4' style={{ marginBottom: "15px", fontWeight: "bold", textAlign: "center" }} sx={{ fontSize: { xs: '28px', sm: '32px', md: '40px' } }}>
                            Have you any queries?
                        </Typography>

                        <Typography variant='p'>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Praesentium doloremque placeat itaque aliquid, temporibus </Typography>
                        <Box style={{ marginTop: "20px" }}>
                            <TextField
                                fullWidth
                                label="Your Full Name"
                                variant="outlined"
                                style={{ marginBottom: 20 }}
                            />
                        </Box>
                        <Box >
                            <TextField

                                fullWidth
                                label="Email Address"
                                variant="outlined"
                                style={{ marginBottom: 20 }}
                            />
                        </Box>
                        <Box >
                            <TextField
                                fullWidth
                                label="Mobile Number"
                                variant="outlined"
                                style={{ marginBottom: 20 }}
                            />
                        </Box>
                        <Box >
                            <TextField
                                fullWidth
                                label="Message"
                                variant="outlined"
                                style={{ marginBottom: 20 }}
                            />
                        </Box>
                        <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            sx={{ py: 1.5, mt: 2, fontSize: '16px', fontWeight: 'bold' }}
                        >
                            Submit Message
                        </Button>
                    </Grid>
                    <Grid item md={6}>

                        <Card style={{ width: "100%", height: "100%" }}>
                            <CardContent>
                                <Box
                                    component="img"
                                    sx={{
                                        height: "100%",
                                        width: "100%",
                                        margin: ' auto'
                                    }}
                                    alt="The house from the offer."
                                    src="./assets/image/contact_us.jpg"
                                />

                                <Box style={{ margin: "20px 0" }}>
                                    <Typography variant="h5" component="div">
                                        Head Office
                                    </Typography>
                                    <Typography variant="p" component="div">
                                        Saltlake, Sector V, Bidhannagar, Kolkata, West Bengal 700091
                                    </Typography>
                                </Box>
                                <Box style={{ margin: "20px 0" }}>
                                    <Typography variant="h5" component="div">
                                        Email Address
                                    </Typography>
                                    <Typography variant="p" component="div">
                                        example@company.com
                                    </Typography>
                                </Box>
                                <Box style={{ margin: "20px 0" }}>
                                    <Typography variant="h5" component="div">
                                        Phone Number
                                    </Typography>
                                    <Typography variant="p" component="div">
                                        +91 9958 996 222
                                    </Typography>
                                </Box>
                            </CardContent>
                        </Card>

                    </Grid>
                </Grid>
            </Container >
        </>
    )
}

export default Home